import { IModalZIndexService } from "../../../abstractions/services/components/IModalZIndexService";

/** Lleva un contador global de z-index para apilar modales: cada modal que se
 *  abre incrementa el valor y lo usa, garantizando que el más reciente quede
 *  por encima de los anteriores. */
class ModalZIndexService implements IModalZIndexService {
  /** z-index actual (base 500; sube con cada modal abierto). */
  private _zIndex = 500;

  /** Incrementa el z-index (al abrir un modal). */
  addZIndex(): void {
    this._zIndex++;
  }

  /** Decrementa el z-index (al cerrar un modal). */
  removeZIndex(): void {
    this._zIndex--;
  }

  /** Retorna el z-index actual. */
  getZIndex(): number {
    return this._zIndex;
  }
}

/** Singleton del contador de z-index de modales. */
export const modalZIndexService = new ModalZIndexService();
